import React from "react";
import Rounter from "./router/router";
import "./app.css";

function App() {
  return (
    <div className="main">
      <Rounter />
      {/* <div className="content">just seek knowledge</div> */}
    </div>
  );
}

export default App;
